import React, { forwardRef } from 'react';

import '../UI/PrintReport.css';
import Template1 from '../Templates/Template1';
import Template2 from '../Templates/Template2';
import Template3 from '../Templates/Template3';
import Template4 from '../Templates/Template4';
import Template5 from '../Templates/Template5/Template5';
import Template6 from '../Templates/Template6/Template6 ';
import Template7 from '../Templates/Template7/Template7';

const TEMPLATES = {
  '1': Template1,
  '2': Template2,
  '3': Template3,
  '4': Template4,
  '5': Template5,
  '6': Template6,
  '7': Template7,
};

// Used only when the report data has no valid template number.
const FALLBACK_TEMPLATE = '5';

// The template number comes from the Get_Print_Report stored procedure. It can
// arrive as a number (3), a space-padded string from a CHAR/NCHAR column ("3   "),
// or be missing. Normalise it so the lab's chosen template is always used.
const resolveTemplate = (reportData) => {
  const raw = reportData?.[0]?.selectedTemplate;
  const key = raw === null || raw === undefined ? '' : String(raw).trim();
  if (TEMPLATES[key]) return key;
  if (reportData?.length) {
    console.warn(
      `PrintReports: selectedTemplate is ${JSON.stringify(raw)} - not a known template, ` +
      `using Template ${FALLBACK_TEMPLATE}. Check that Get_Print_Report returns SelectedTemplate.`
    );
  }
  return FALLBACK_TEMPLATE;
};

const PrintReports = forwardRef(({ reportData, QrCodeURL }, ref) => {
  const Template = TEMPLATES[resolveTemplate(reportData)];
  return (
    <div ref={ref}>
      <Template reportData={reportData} QRurl={QrCodeURL} />
    </div>
  );
});

export default PrintReports;
